var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left icon",
    clipPath: "url(#clip0_0_228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4244 21L13.3372 22.0872C12.3499 23.0585 11.0188 23.6004 9.63385 23.5947C8.24889 23.5891 6.92225 23.0364 5.94292 22.0571C4.96359 21.0777 4.41091 19.7511 4.40528 18.3661C4.39964 16.9812 4.94149 15.6501 5.91281 14.6628L8.54984 12.0313C9.49574 11.0834 10.7681 10.5329 12.1065 10.4922C13.4449 10.4516 14.7483 10.9239 15.75 11.8125",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4858A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.5756 7L14.6628 5.91281C15.6501 4.94149 16.9812 4.39964 18.3661 4.40528C19.7511 4.41091 21.0777 4.96359 22.0571 5.94292C23.0364 6.92225 23.5891 8.24889 23.5947 9.63385C23.6004 11.0188 23.0585 12.3499 22.0872 13.3372L19.4502 15.9742C18.5036 16.9213 17.2309 17.4708 15.8924 17.5105C14.554 17.5501 13.251 17.0769 12.25 16.1875",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4858A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.b23fdfa0d88c4288c94af0968cc78feb.svg";
export { ForwardRef as ReactComponent };